/*
 * File: c:\Users\j.mazat\Desktop\AutobuyBackOffice\AutobuyBackOffice\src\Content\HomePage\HomePage.tsx
 * Project: c:\Users\j.mazat\Desktop\AutobuyBackOffice\AutobuyBackOffice
 * Created Date: Wednesday June 7th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Thursday, 26th September 2024 09:49:14
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import RouterPathResolver from "Config/Router/RouterPathResolver";
import Table from "Content/Table/Table";
import translator from "MultiLanguage/TranslationWrapper";
import { MouseEventHandler, useEffect, useMemo, useState } from "react";
import { NavigateFunction, useLoaderData, useNavigate } from "react-router-dom";
import { CarsIntels, OfferIntels, UserIntels } from "Type/homePageInfo.type";
import TableUtils from "Utils/TableFormat";
import Style from "Content/HomePage/HomePage.module.css";
import ModalAddCar from "Content/Modals/ModalAddCar/ModalAddCar";
import { TableCell, TableRow } from "@mui/material";
import PostItDisplay from "./PostItDisplay";

const buildMyOffersRows = (offers: OfferIntels, navigate: NavigateFunction) => {
    const styling = {width:`${100/7}%`};
    const navTab = (tab: "all" | "pending" | "accepted" | "reserved" | "cancel") => {
        navigate(`${RouterPathResolver.pathOffers.path}?tabkey=${tab}`);
    };
    return [<TableRow key={`row-user`} >
        <TableCell style={styling} key={`row-offer-total`} onClick={() => navTab("all")} >{offers.total}</TableCell>
        <TableCell style={styling} key={`row-offer-new`} onClick={() => navTab("pending")} >{offers.pending}</TableCell>
        <TableCell style={styling} key={`row-offer-pending`} onClick={() => navTab("accepted")} >{offers.accepted}</TableCell>
        <TableCell style={styling} key={`row-offer-valid`} onClick={() => navTab("reserved")} >{offers.reserved}</TableCell>
        <TableCell style={styling} key={`row-offer-archived`} onClick={() => navTab("cancel")} >{offers.cancel}</TableCell>
    </TableRow>];
};

const buildMyRowsUsers = (usersInfo: UserIntels, navigate: NavigateFunction) => {
    const styling = {width:`${100/7}%`};
    return [<TableRow key={`row-user`} onClick={() => navigate(RouterPathResolver.pathUser.path)}>
        <TableCell style={styling} key={`row-user-total`}>{usersInfo.total}</TableCell>
        <TableCell style={styling} key={`row-user-new`}>{usersInfo.newUser}</TableCell>
        <TableCell style={styling} key={`row-user-pending`}>{usersInfo.pendingUser}</TableCell>
        <TableCell style={styling} key={`row-user-valid`}>{usersInfo.validUser}</TableCell>
        <TableCell style={styling} key={`row-user-archived`}>{usersInfo.archivedUser}</TableCell>
    </TableRow>];
};

const buildMyRows = (data: CarsIntels, handleAddCar: MouseEventHandler, navigate: NavigateFunction, handleSynchroCar: MouseEventHandler) => {
    const styling = {width:`${75/6}%`};
    const navTab = (tab: "stock" | "archived" | "selling" | "sold"| "reserved") => {
        navigate(`${data.path}?tabkey=${tab}`);
    };
    return [<TableRow key={`row-carinfo`} >
        <TableCell style={styling} onClick={() => navTab("stock")}>{data.total}</TableCell>
        <TableCell style={styling} onClick={() => navTab("selling")}>{data.selling}</TableCell>
        <TableCell style={styling} onClick={() => navTab("sold")}>{data.sold}</TableCell>
        <TableCell style={styling} onClick={() => navTab("reserved")}>{data.reserved}</TableCell>
        <TableCell style={styling} onClick={() => navTab("archived")}>{data.archived}</TableCell>
        <TableCell style={{width:`25%`}} key={`row-user-action`}>
            <button onClick={ handleAddCar } className="btn btn-primary me-3">{translator.decode("dynamic.add")}</button>
            <button onClick={ handleSynchroCar } className="btn btn-primary">{translator.decode("dynamic.synchro")}</button>
        </TableCell>
    </TableRow>];
};

// const buildStats = (data: GlobalUsageIntel, navigate: NavigateFunction) => {
//     return [<TableRow key={`row-connexion`} style={{cursor: "cursor"}} onClick={() => navigate(`${RouterPathResolver.pathStats.path}?tabkey=connexion`)}>
//                 <TableCell key={`row-connexion-title`}><span>{translator.decode("home.connexion")}</span></TableCell>
//                 <TableCell key={`row-connexion-today`}><span className={`${Style.boldText} text-success`}>{data.connexions.today.success}</span>/<span className={`${Style.boldText} text-danger`}>{data.connexions.today.failed}</span></TableCell>
//                 <TableCell key={`row-connexion-thisWeek`}><span className={`${Style.boldText} text-success`}>{data.connexions.thisWeek.success}</span>/<span className={`${Style.boldText} text-danger`}>{data.connexions.thisWeek.failed}</span></TableCell>
//                 <TableCell key={`row-connexion-thisMonth`}><span className={`${Style.boldText} text-success`}>{data.connexions.thisMonth.success}</span>/<span className={`${Style.boldText} text-danger`}>{data.connexions.thisMonth.failed}</span></TableCell>
//         </TableRow>,
//         <TableRow key={`row-seenCars`} style={{cursor: "cursor"}} onClick={() => navigate(`${RouterPathResolver.pathStats.path}?tabkey=seencar`)}>
//             <TableCell key={`row-seenCar-title`}><span>{translator.decode("home.seenCar")}</span></TableCell>
//             <TableCell key={`row-seenCar-today`}><span>{data.seenCars.today}</span></TableCell>
//             <TableCell key={`row-seenCar-thisWeek`}><span>{data.seenCars.thisWeek}</span></TableCell>
//             <TableCell key={`row-seenCar-thisMonth`}><span>{data.seenCars.thisMonth}</span></TableCell>
//         </TableRow>,
//         <TableRow key={`row-offers`} style={{cursor: "cursor"}} onClick={() => navigate(`${RouterPathResolver.pathStats.path}?tabkey=offer`)}>
//             <TableCell key={`row-offer-title`}><span>{translator.decode("home.offer")}</span></TableCell>
//             <TableCell key={`row-offer-today`}><span>{data.offers.today}</span></TableCell>
//             <TableCell key={`row-offer-thisWeek`}><span>{data.offers.thisWeek}</span></TableCell>
//             <TableCell key={`row-offer-thisMonth`}><span>{data.offers.thisMonth}</span></TableCell>
//         </TableRow>,
//         <TableRow key={`row-email`} style={{cursor: "cursor"}} onClick={() => navigate(`${RouterPathResolver.pathStats.path}?tabkey=email`)}>
//             <TableCell key={`row-email-title`}><span>{translator.decode("home.email")}</span></TableCell>
//             <TableCell key={`row-email-today`}><span>{buildEmailStats(data.email.day)}</span></TableCell>
//             <TableCell key={`row-email-thisWeek`}><span>{buildEmailStats(data.email.week)}</span></TableCell>
//             <TableCell key={`row-email-thisMonth`}><span>{buildEmailStats(data.email.month)}</span></TableCell>
//         </TableRow>];
// };

function HomePage(_: any) {
    const navigate = useNavigate();
    const loadData = useLoaderData() as Promise<any>[];
    const translateKey = "home.headers.";
    const keysCars = ["total", "selling", "sold", "reserved", "archived", "action"];
    const keysUser = ["total", "new", "pending", "valid", "archived"];
    const keysUsage = ["total", "pending", "sold", "reserved", "cancel"];
    const dataTableCars = TableUtils.initFormatRowCreateHeader(keysCars, translateKey);
    const dataTableUser = TableUtils.initFormatRowCreateHeader(keysUser, translateKey);
    const dataTableUsage = TableUtils.initFormatRowCreateHeader(keysUsage, "Status.");
    const [showModalCar, setShowModalCar] = useState(false);
    const [archive, setArchive] = useState(false);
    const [offersInfo, setOffersInfos] = useState({
        total: 0,
        pending: 0,
        accepted: 0,
        reserved: 0,
        cancel: 0
    });
    const [userInfos, setUserInfos] = useState({
        total: 0,
        newUser: 0,
        validUser: 0,
        pendingUser: 0,
        archivedUser: 0
    });
    const [carInfos, setCarInfos] = useState({
        title: "",
        path: "",
        total: 0,
        selling: 0,
        reserved: 0,
        sold: 0,
        archived: 0
    });

    useEffect(() => {
        Promise.all(loadData).then(result => {
            setUserInfos(result[0]);
            setCarInfos(result[1]);
            setOffersInfos({total: Object.values(result[2]).reduce((a, b: any) => a + b, 0), ...result[2]});
        }).catch((error) => {
            console.log(error);
        })
        ;
    }, []);

    const handleAddCar = (e: any) => {
        e.stopPropagation();
        setShowModalCar(true);
        setArchive(false);
    };
    const handleSynchroCar = (e: any) => {
        e.stopPropagation();
        setShowModalCar(true);
        setArchive(true);
    };

    const handleToggleCarModal = (e: React.MouseEvent<HTMLElement>) => {
        setShowModalCar(false);
    };

    const userIntels = useMemo(() => {
        return buildMyRowsUsers(userInfos, navigate);
    }, [userInfos]);

    const offerIntels = useMemo(() => {
        return buildMyOffersRows(offersInfo, navigate);
    }, [offersInfo]);

    const carIntels = useMemo(() => {
        return buildMyRows(carInfos, handleAddCar, navigate, handleSynchroCar);
    }, [carInfos]);

    return(
        <div className={`${Style.homePage}`}>
            <div className={`${Style.tables}`}>
                <div>
                    <h2>{translator.decode("home.offer")}</h2>
                    <Table className={`${Style.table}`} rows={offerIntels} header={dataTableUsage.header} nbTotalElement={0} pagination={false} />
                </div>
                <div>
                    <h2>{translator.decode("home.users")}</h2>
                    <Table className={`${Style.table}`} rows={userIntels} header={dataTableUser.header} nbTotalElement={0} pagination={false} />
                </div>
                <div>
                    <h2>{translator.decode("home.cars")}</h2>
                    <Table className={`${Style.table}`} rows={carIntels} header={dataTableCars.header} nbTotalElement={0} pagination={false} />
                </div>
            </div>
            <PostItDisplay />
            <ModalAddCar title={translator.decode("dynamic.add")} show={showModalCar} onClose={handleToggleCarModal} closeModal={handleToggleCarModal} archive={archive} />
        </div>
    );
};

export default HomePage;
